/*@ngInject*/
const FocusManagerDirective = function ($timeout, browserUtil) {

    const linkFunction = function ($scope) {

        $scope.setFocus = function (targetClass, event) {
            $timeout(() => {
                const targetElement = document.querySelector(targetClass);
                let isEventTargetFormFieldComponent = false;

                if (!_.isNil(event)) {
                    const eventTarget = $(event.target);
                    isEventTargetFormFieldComponent = !_.isEmpty(eventTarget.parents('.formComponentContainer'));
                }

                if (targetElement && !isEventTargetFormFieldComponent) {
                    targetElement.focus();
                    if (browserUtil.isIE11()) {
                        if (targetElement instanceof HTMLInputElement && !_.isNil(targetElement.value)) {
                            // IE fix to move the cursor to the end of the value.
                            targetElement.setSelectionRange(targetElement.value.length, targetElement.value.length);
                        }
                    }
                }
            }, 100);
        };
    };

    return {
        link: linkFunction,
        restrict: 'E'
    };
};

angular.module('umCore')
    .directive('umFocusManager', FocusManagerDirective);
